import React, { useState, useEffect } from 'react';
import Result from './result';
import CustomQuizMobile from './CustomQuizMobile';
import CustomQuiz from './CustomQuiz';
import perfectCorp from 'Configuration/perfectCorp';
import content from 'Content/content.json';
import contentQuizMap from 'Content/contentQuizMap.json';
import { FormattedMessage } from 'react-intl';
import { pageDefaultTitle } from 'Root/constants';
import './CustomQuiz.scss';

const language = perfectCorp.language;
const data = content['data'];
const quiz = data['quiz'][language];
const quizResultMap = contentQuizMap['data'];
const detectDevice = () => {
  let device = '';
  if (
    /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  )
    device = 'smartphone';

  return device;
};

const initialOptions =
  quiz &&
  quiz.reduce((accu, item, index) => {
    const key = `q${index + 1}`;
    accu[key] = null;
    return accu;
  }, {});

const Quiz = () => {
  const [options, setOptions] = useState(initialOptions);
  const [showResult, setShowResult] = useState(false);
  const [btnState, setBtnState] = useState(true);
  const [resultType, setResultType] = useState('');
  const device = detectDevice();

  useEffect(() => {
    document.title = pageDefaultTitle + "|quiz";
    return () => {
      document.title = pageDefaultTitle;
    }
  }, []);

  useEffect(() => {
    let optionValues = Object.values(options);
    setBtnState(optionValues.some((option) => option === null));
  }, [options]);

  const handleChange = (e) => {
    setOptions({
      ...options,
      [e.target.name]: e.target.value,
    });
  };

  const handleClick = () => {
    let result = Object.values(options).join('');
    setResultType(quizResultMap[result]);
    setShowResult(true);
  };
  return (
    <div
      className={`quiz-component quiz-component-custom ${
        device === 'smartphone' ? 'quiz-component-custom--mobile' : ''
      }`}
    >
      <div className="component-wrapper">
        <h2>
          {!showResult ? (
            <FormattedMessage
              id="dba.about_urself"
              defaultMessage="Tell us more about yourself"
            />
          ) : (
            <FormattedMessage id="dba.type" defaultMessage="Your type" />
          )}
        </h2>
        {!showResult ? (
          <div
            className={`quiz-items quiz-items--custom ${
              device === 'smartphone' ? 'quiz-items--custom-mobile' : ''
            }`}
          >
            <div className="help-text">
              <FormattedMessage
                id="quiz.help"
                defaultMessage="All questions are mandatory"
              />
            </div>
            {device === 'smartphone' ? (
              <CustomQuizMobile
                data={quiz}
                optionChange={handleChange}
                displayResult={handleClick}
              />
            ) : (
              <CustomQuiz
                data={quiz}
                optionChange={handleChange}
                onFinish={handleClick}
                btnState={btnState}
              />
            )}
          </div>
        ) : (
          <div className="quiz-items quiz-items--custom quiz-items--result">
            <Result resultType={resultType} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Quiz;
